__turbopack_context__.v({
  "badge": "ogBXTW_badge",
  "badgePulse": "ogBXTW_badgePulse",
  "glow": "ogBXTW_glow",
  "progressCard": "ogBXTW_progressCard",
  "progressGlow": "ogBXTW_progressGlow",
  "shimmer": "ogBXTW_shimmer",
  "timerPulse": "ogBXTW_timerPulse",
  "urgent": "ogBXTW_urgent",
  "wiggle": "ogBXTW_wiggle",
});
